"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFuturesTrialBalance = void 0;
const decimal_js_1 = __importDefault(require("decimal.js"));
const react_1 = require("react");
const trade_utils_lib_1 = require("trade_utils_lib");
const FutureAPI_1 = require("../../../apis/FutureAPI");
/**获取合约体验金 */
function useFuturesTrialBalance() {
    const [trialBalance, setTrialBalance] = (0, react_1.useState)("");
    const [transferable, setTransferable] = (0, react_1.useState)("");
    const refresh = (0, react_1.useCallback)(() => (0, FutureAPI_1.queryTrialBalance)().subscribe({
        next: (res) => {
            const balances = res.balances || [];
            const { trial_amount = "", transferable: _transferable = "" } = balances.find((it) => it.coin === "USDT") || {};
            const amountD = new trade_utils_lib_1.SafeDecimal(trial_amount);
            const amount = amountD.gt(0) ? amountD.toFixed(2, decimal_js_1.default.ROUND_DOWN) : "";
            setTrialBalance(amount);
            setTransferable(_transferable);
        },
        error: () => { }
    }), []);
    (0, react_1.useEffect)(() => {
        const sub = refresh();
        return () => sub.unsubscribe();
    }, [refresh]);
    return { trialBalance, transferable, refresh };
}
exports.useFuturesTrialBalance = useFuturesTrialBalance;
